export default "__VITE_ASSET__DBiO_SLL__"